import HeaderDescription from "../components/HeaderDescription";
import ProfileHeaderSection from "../components/ProfileHeaderSection";
import { BackButton } from "../components/forms/DashboardButton";
import HeaderBox from "../components/Box/HeaderBox";

import Screen from "../components/Screen";
import { useNavigate } from "react-router-dom";
import UnionSet from "../components/UnionSet";
import { useGetAnnualGoals } from "../hooks/useGoals";

const Annual = () => {
  const navigate = useNavigate();

  const handlePrev = () => {
    navigate("/quarterly-goals");
  };
  const { goals, isPending } = useGetAnnualGoals();

  const hospital = goals?.[0]?.hospital ?? 0;
  const revenue = goals?.[0]?.reveune ?? 0;
  const spent = goals?.[0]?.spent ?? 0;
  return (
    <div className="bg-white w-full">
      <Screen>
        <ProfileHeaderSection />
        <HeaderDescription
          maintext={"Dashboard"}
          subtext={"Our Team"}
          subsubtext={"Annual Goals"}
        />
        <p className={` text-4xl text-lightDark my-4`}>Annual Goals</p>
        <div className="">
          <HeaderBox text="Our Annual Goals" />
        </div>
        <div className={` text-black  mt-4 text-basetext leading-7 text-left`}>
          Here are our goals for 2024. We can achieve these if we all work hard
          and give our best! Let’s go!
        </div>

        <div className="w-full flex flex-col lg:flex-row justify-between lg:h-96 h-screen rounded mt-4 bg-orange gap-2">
          <div className="lg:w-6/12  px-2 py-4 h-5/6 flex flex-col justify-center ">
            <p className={`text-black text-3xl mb-4 `}>
              The <span className={`text-lightRed text-2xl `}>Market</span>
            </p>
            <div>
              <p className={`text-black  text-basetext leading-7`}>
                We project annual revenue based on the number of hospitals and
                their average spend. Meeting our targets with 1,698 hospitals
                and an average spend of $1,059 per hospital will yield
                approximately $1.8 million in annual revenue.
              </p>
            </div>
          </div>
          <div className="lg:w-6/12 flex items-start justify-center h-full">
            <div className="flex items-center h-2/5 justify-center">
              <UnionSet
                hospital={hospital}
                spent={spent}
                revenue={revenue}
                loading={isPending}
              />
            </div>
          </div>
        </div>

        <div className="my-4 flex justify-end">
          <BackButton
            text={"Previous"}
            onClick={handlePrev}
            subText={"Quarterly Goals"}
          />
        </div>
      </Screen>
    </div>
  );
};

export default Annual;
